import { Route, Routes } from 'react-router';
import NotFoundPage from '@src/pages/NotFound.page';
import { FiscalRepRequestCancellationPage } from './request-cancellation/request-cancellation.page';

export function FiscalRepRoutes(): JSX.Element {
  return (
    <Routes>
      <Route
        path="request-cancellation/:id/*"
        element={<FiscalRepRequestCancellationPage />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
